import React from 'react'

const policies = {
  privacy: {
    title: 'Privacy Policy',
    intro: 'This policy explains how Millennium Realty handles information submitted through this website.',
    sections: [
      {
        heading: 'Information we collect',
        body: 'We may receive the contact details, property information, and message content you choose to send by email or through a website form. We also store your language preference in your browser so the site can remember your selection.',
      },
      {
        heading: 'How we use information',
        body: 'We use submitted information to respond to inquiries, discuss requested services, maintain business records, and protect the security and operation of the website. We do not sell personal information.',
      },
      {
        heading: 'Third-party services',
        body: 'The website may load services from Google, including Maps and Translate, and may link to third-party property listing websites. Those providers process information under their own privacy policies.',
      },
      {
        heading: 'Retention and your choices',
        body: 'We retain inquiry records only as long as reasonably needed for business, legal, and security purposes. You may ask about, correct, or request deletion of personal information by contacting us, subject to applicable legal exceptions.',
      },
    ],
  },
  terms: {
    title: 'Terms & Conditions',
    intro: 'By using this website, you agree to the following website terms.',
    sections: [
      {
        heading: 'Website information',
        body: 'Website content and property availability are provided for general informational purposes and may change without notice. Nothing on this website is legal, tax, financial, or investment advice.',
      },
      {
        heading: 'Listings and services',
        body: 'Listing details should be independently verified. Property management, brokerage, leasing, and other professional services are governed by the written agreement signed with Millennium Realty; that agreement controls if it conflicts with this website.',
      },
      {
        heading: 'Acceptable use',
        body: 'You may not misuse the website, attempt unauthorized access, interfere with its operation, or copy site content for unlawful or misleading purposes.',
      },
      {
        heading: 'Third-party links and availability',
        body: 'Links to third-party websites are provided for convenience. Millennium Realty does not control their content or availability. The website is provided as available, to the extent permitted by law.',
      },
    ],
  },
  refund: {
    title: 'Refund Policy',
    intro: 'This website does not process online purchases or collect service fees directly.',
    sections: [
      {
        heading: 'Service fees',
        body: 'Any management, leasing, brokerage, application, or other fee is governed by the applicable written agreement, disclosure, or payment terms provided when the service is arranged.',
      },
      {
        heading: 'Refund requests',
        body: 'If you believe a payment was made in error or have a question about a charge, contact Millennium Realty promptly. Eligibility and timing for any refund will be determined by the applicable agreement and law.',
      },
    ],
  },
}

const Legal = ({ type }) => {
  const policy = policies[type] || policies.terms

  return (
    <main className="min-h-[60vh] bg-black px-5 py-12 text-white sm:px-8 lg:px-16 lg:py-20">
      <article className="mx-auto max-w-[900px] rounded-[18px] border border-[#262626] bg-[#111] p-6 sm:p-10">
        <p className="text-sm font-semibold uppercase tracking-[0.14em] text-[#EEC24B]">Last updated August 22, 2026</p>
        <h2 className="mt-3 text-3xl font-bold text-gradient sm:text-5xl">{policy.title}</h2>
        <p className="mt-5 text-base leading-relaxed text-white/80 sm:text-lg">{policy.intro}</p>

        <div className="mt-8 space-y-8">
          {policy.sections.map((section) => (
            <section key={section.heading}>
              <h3 className="text-xl font-bold text-white sm:text-2xl">{section.heading}</h3>
              <p className="mt-3 text-base leading-relaxed text-white/75">{section.body}</p>
            </section>
          ))}
        </div>

        <section className="mt-10 border-t border-[#262626] pt-8">
          <h3 className="text-xl font-bold text-white">Contact</h3>
          <p className="mt-3 leading-relaxed text-white/75">
            Millennium Realty, 2480 Mission Street, Suite 108, San Francisco, CA 94110<br />
            <a className="text-[#EEC24B] hover:underline" href="mailto:info@millenniumrealtysf.com">info@millenniumrealtysf.com</a>
            {' · '}
            <a className="text-[#EEC24B] hover:underline" href="tel:+14156107765">415-610-7765</a>
          </p>
        </section>
      </article>
    </main>
  )
}

export default Legal
